import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import Select from 'react-select';
import { Row, Col, Button, Input } from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import { companyCodeTitle } from '../../actions/root_url';

const CARD_TYPE = {
  VISA: 'Visa',
  MASTER: 'Master',
  AMEX: 'American Express',
  DISCOVER: 'Discover',
};

class MSOPaymentInfo extends Component {
  constructor(args) {
    super(args);
    this.state = {
      error: null,
      info: {
        captured: false,
        amount: 0.00,
        amountRefunded: 0.00,
        amountInvoice: 0.00,
        amountDelivery: 0.00,
        amountTip: 0.00,
        amountCharged: 0.00,
        net: 0.00,
        fee: 0.00,
        name: null,
        date: null,
        last4: null,
        paypalEmail: null,
        currency: 'usd',
        brand: null,
        cardType: null,
        address: {
          line1: null,
          line2: null,
          city: null,
          state: null,
          zip: null,
        },
        refunded: false,
        refunds: [],
      },
      refundReason: '',
      refundOption: 'full',
      refundAmount: 0.00,
      refundAmountIllegal: false,
    };
  }

  componentDidMount() {
    const { info } = this.props;
    this.setStateWithProps(info);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.info !== nextProps.info) {
      this.setStateWithProps(nextProps.info);
    }
  }

  setStateWithProps(info) {
    let date = info.Created ? new Date(info.Created * 1000) : null;
    if (date) {
      date = date.setDate(date.getDate() + 7);
    }
    if (info) {
      this.setState({
        info: {
          amount: info.Amount ? info.Amount : 0.00,
          amountRefunded: info.Amount_Refunded ? info.Amount_Refunded : 0.00,
          amountInvoice: info.Amount_Invoice ? info.Amount_Invoice : 0.00,
          amountDelivery: info.Amount_Delivery ? info.Amount_Delivery : 0.00,
          amountTip: info.Amount_Tip ? info.Amount_Tip : 0.00,
          amountCharged: info.Amount_Charged ? info.Amount_Charged : 0.00,
          net: info.Net_Receive ? info.Net_Receive : 0.00,
          fee: info.Fee ? info.Fee : 0.00,
          date,
          last4: info.Last_Four ? info.Last_Four : null,
          paypalEmail: info.PaypalEmail ? info.PaypalEmail : null,
          currency: info.Currency ? info.Currency : 'usd',
          brand: info.Brand ? info.Brand : null,
          cardType: info.Card_Type ? info.Card_Type : null,
          captured: info.Captured ? info.Captured : false,
          name: info.Name ? info.Name : this.props.Billing.FirstName + ' ' + this.props.Billing.LastName,
          address: {
            line1: info.Address_Line1,
            line2: info.Address_Line2,
            city: info.Address_City,
            state: info.Address_State,
            zip: info.Address_Zip,
          },
          refunded: info.Refunded,
          refunds: info.Refunds,
          method: info.Method,
          isYuansfer: info.IsYuansfer,
        },
        refundAmount: info.Amount_Charged.toFixed(2),
        error: info.Error ? info.error : null,
      });
    }
  }

  getBrand(brand) {
    if (brand === CARD_TYPE.VISA) {
      return 'fa-cc-visa';
    } else if (brand === CARD_TYPE.MASTER) {
      return 'fa-cc-mastercard';
    } else if (brand === CARD_TYPE.AMEX) {
      return 'fa-cc-amex';
    } else if (brand === CARD_TYPE.DISCOVER) {
      return 'fa-cc-discover';
    }
  }

  /*
    button status :
      0: initial state
      200: success
      400: failure
  */
  buttonStatus(captured, status) {
    const { error } = this.state;
    if (error) {
      return 'danger';
    }
    if (captured && status === 0) {
      return 'warning';
    }
    if (this.props.info.Method) {
      if (this.props.info.Method === 'alipay' || this.props.info.Method === 'wechatpay') {
        return 'warning';
      } 
    }
    if (status === 200) {
      return 'success';
    } else if (status === 400) {
      return 'danger';
    }
    return '';
  }

  buttonText(captured, status) {
    const { error } = this.props.refund;
    // const { captured } = this.props.info;
    if (error) {
      return <Translate value="error" />;
    }
    if (captured && status === 0) {
      return <Translate value="refund" />;
    }
    if (this.props.info.Method) {
      if (this.props.info.Method === 'alipay' || this.props.info.Method === 'wechatpay') {
        return <Translate value="refund" />;
      } 
    }
    if (status === 200) {
      return <Translate value="refund_successful" />;
    }
    return <Translate value="release" />;
  }

  handlePaymentButtonClick(event) {
    event.preventDefault();
    const { refundAmount, refundReason } = this.state;
    this.props.openConfirmRefund({ refundAmount, refundReason });
  }

  handleRefundOptionChange(event) {
    const refundOption = event.target.value;
    this.setState({
      refundOption,
    });

    const { amountCharged } = this.state.info;
    if (refundOption === 'full') {
      this.setState({
        refundAmountIllegal: false,
        refundAmount: amountCharged.toFixed(2),
      });
    }
  }

  handleRefundAmountChange(event) {
    const refundAmount = event.target.value;
    const illegal = !(/^\d+\.\d(\d?)$/.test(refundAmount) || /^\d+$/.test(refundAmount));
    if (illegal) {
      this.setState({
        refundAmountIllegal: true,
        refundAmount: event.target.value,
      });
      return;
    }
    this.setState({
      refundAmountIllegal: false,
      refundAmount: event.target.value,
    });
  }

  handleRefundAmountKeyPress(event) {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    // only allows numbers and '.'
    if (!/\d|\./.test(keyValue)) {
      event.preventDefault();
    }
  }

  handleRefundReasonChange(selection) {
    this.setState({
      refundReason: selection ? selection.value : '',
    });
  }

  buttonShouldDisable(props) {
    const {
      loading, status, refunded, refundAmountIllegal,
    } = props;
    if (loading || refunded) {
      return true;
    }
    if (status !== 0) {
      return true;
    }
    if (refundAmountIllegal) {
      return true;
    }
    return false;
  }

  renderAddress() {
    const { address } = this.state.info;
    const seperator = address.city && address.state ? ',' : '';
    return (
      <Row>
        <Col xs={12}>
          <Row className="justify-content-start">
            <Col xs={12}>
              <label><Translate value="billing_address" /></label>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xs={12}>
              <label>{ address.line1 }</label>
            </Col>
            { address.line2 ?
              <Col xs={12}>
                <label>{ address.line2 }</label>
              </Col>
              :
              null
            }
            <Col xs={12}>
              <label>{ address.city }{ seperator }&nbsp;{ address.state }&nbsp;{ address.zip }</label>
            </Col>
          </Row>

        </Col>
      </Row>
    );
  }

  renderRefundButton() {
    const { loading, status } = this.props.refund;
    const { info: { captured, refunded }, refundAmountIllegal } = this.state;
    let buttonIcon;
    if (loading) {
      buttonIcon = 'fa-spinner fa-spin';
    } else if (status === 200) {
      buttonIcon = 'fa-check-circle-o fa-lg';
    } else {
      buttonIcon = 'fa-undo';
    }
    return (
      <Button
        block
        bsStyle={this.buttonStatus(captured, status)}
        onClick={this.handlePaymentButtonClick.bind(this)}
        disabled={this.buttonShouldDisable({ loading, status, refunded, refundAmountIllegal })}
      >
        <i className={`fa ${buttonIcon}`} aria-hidden="true" />
        &nbsp;{ this.buttonText(captured, status) }
      </Button>
    );
  }

  renderPrint() {
    const { orderID } = this.props;
    const { info: { refunds } } = this.state;
    const { error, status } = this.props.refund;
    const buttonShouldEnable = (status === 200) || ((Array.isArray(refunds)) && refunds.length > 0);
    return (
      <Button
        block
        bsStyle="primary"
        type="button"
        onClick={() => { this.props.printMSORefundPDF(orderID); }}
        disabled={!buttonShouldEnable}
      >
        <Translate value="refund_summary" />
      </Button>
    );
  }

  renderRefundOptions() {
    const { refundOption, refundAmount, refundAmountIllegal } = this.state;
    return (
      <ContentWrapper>
        <Col xs={12}>
          <label><Translate value="refund_type" /></label>
        </Col>
        <Col xs={12}>
          <Row>
            <fieldset>
              <Col xs={6} className="refund-options-group">
                <label>
                  <input
                    type="radio"
                    value="full"
                    checked={refundOption === 'full'}
                    onChange={this.handleRefundOptionChange.bind(this)}
                  />
                    Full
                </label>
              </Col>
              <Col xs={6} className="refund-options-group">
                <label>
                  <input
                    type="radio"
                    value="partial"
                    checked={refundOption === 'partial'}
                    onChange={this.handleRefundOptionChange.bind(this)}
                  />
                    Partial
                </label>
              </Col>
              <Col xs={12} className="refund-options-group">
                <Input
                  className={refundAmountIllegal ? 'error' : ''}
                  name="refund-amount"
                  type="text"
                  placeholder="refund amount xxx.xx"
                  disabled={refundOption === 'partial' ? false : 'disabled'}
                  value={refundAmount}
                  onChange={this.handleRefundAmountChange.bind(this)}
                  onKeyPress={this.handleRefundAmountKeyPress}
                />
              </Col>
            </fieldset>
          </Row>
        </Col>
      </ContentWrapper>
    );
  }

  renderRefundReasons() {
    const { refundReason } = this.state;
    const returnReasonOptions = [
      { value: 'damaged', label: 'Damaged' },
      { value: 'defective', label: 'Defective' },
      { value: 'no_need', label: 'No Need' },
      { value: 'repair', label: 'Repair' },
      { value: 'wrong_item', label: 'Wrong Item' },
      { value: "missing", label: "Missing" },
      { value: 'other', label: 'Other' },
      { value: 'out', label: 'Out' },
      { value: 'short', label: 'Short' },
    ];
    return (
      <ContentWrapper>
        <Col xs={12}>
          <label><Translate value="refund_reason" /></label>
        </Col>
        <Col xs={12}>
          <Select
            className="testSelect"
            value={refundReason}
            options={returnReasonOptions}
            onChange={this.handleRefundReasonChange.bind(this)}
          />
        </Col>
      </ContentWrapper>
    );
  }

  // renderAmountRefunded() {
  //   const { refunded, amountRefunded } = this.state.info;
  //   if (refunded) {
  //     return (
  //       <Col xs={12}>
  //         <label><Translate value="refund" /></label>
  //         <label className='pull-right'><span className='dollar-sign'>$</span>{ amountRefunded.toFixed(2) }</label>
  //       </Col>
  //     );
  //   }
  //   return <ContentWrapper />;
  // }

  renderPaymentDetails() {
    const {
      amount, fee, date, last4, brand, name, captured,
      amountInvoice, amountCharged, amountRefunded,
      amountDelivery, amountTip, net, method, isYuansfer,
      paypalEmail, cardType,
    } = this.state.info;

    return (
      <Row>
        <Col xs={12}>
          <h4><Translate value="payment_details" /></h4>
        </Col>
        <Col xs={12}>
          <label><Translate value="name" /></label>
          <label className="pull-right">{ name }</label>
        </Col>
        { isYuansfer &&
        <Col xs={12}>
          <label><Translate value="method" /></label>
          <label className="pull-right">{ method }</label>
        </Col>
        }
        {(!isYuansfer && !paypalEmail) &&
          <Col xs={12}>
            { (cardType === "ACH") && <label><Translate value="bank_account" /></label> }
            { (cardType !== "ACH") && <label><Translate value="credit_card" /></label> }
            <label className="pull-right">
              <i className={`fa ${this.getBrand(brand)} fa-lg`} />&nbsp;{last4}
            </label>
          </Col>
        }
        {(!isYuansfer && paypalEmail) &&
          <Col xs={12}>
            <label><Translate value="paypal" /></label>
            <label className="pull-right">
              <i className={`fa ${this.getBrand(brand)} fa-lg`} />&nbsp;{paypalEmail}
            </label>
          </Col>
        }
          <Col xs={12}>
            <label><Translate value="order" /></label>
            <label className="pull-right"><span className="dollar-sign">$</span>{ this.props.totalPrice.toFixed(2) }</label>
          </Col>

            {/* <Col xs={12}>
            <label><Translate value="order" /></label>
            <label className="pull-right"><span className="dollar-sign">$</span>{ amount.toFixed(2) }</label>
          </Col> */}
        {/* <Col xs={12}>
          <label><Translate value="invoice" /></label>
          <label className="pull-right"><span className="dollar-sign">$</span>{ amountInvoice.toFixed(2) }</label>
        </Col> */}
        <Col xs={12}>
          <label><Translate value="delivery" /></label>
          <label className="pull-right"><span className="dollar-sign">$</span>{ amountDelivery.toFixed(2) }</label>
        </Col>
          <Col xs={12}>
            <label><Translate value="credit" /></label>
            <label className="pull-right"><span className="dollar-sign">-$</span>{ this.props.credit.toFixed(2) }</label>
          </Col>
        <Col xs={12}>
          <label><Translate value="tip" /></label>
          <label className="pull-right"><span className="dollar-sign">$</span>{ amountTip.toFixed(2) }</label>
        </Col>
        <Col xs={12}>
          <label><Translate value="transaction_fee" /></label>
          <label className="pull-right"><span className="dollar-sign">$</span>{ fee.toFixed(2) }</label>
        </Col>
        <Col xs={12}>
          <label><Translate value="charged" /></label>
          <label className="pull-right"><span className="dollar-sign">$</span>{ amountCharged.toFixed(2) }</label>
        </Col>
        <Col xs={12}>
          <label><Translate value="refund" /></label>
          <label className="pull-right"><span className="dollar-sign">$</span>{ amountRefunded.toFixed(2) }</label>
        </Col>
        <Col xs={12}>
          <label><Translate value="net" /></label>
          <label className="pull-right"><span className="dollar-sign">$</span>{ net.toFixed(2) }</label>
        </Col>
        <Col xs={12}>
          <label><Translate value="cc_hold_until" /></label>
          <label className="pull-right">{ date ? Intl.DateTimeFormat().format(date) : '' }</label>
        </Col>
      </Row>
    );
  }

  renderRefundError() {
    const { error } = this.props.refund;

    if (error) {
      return (
        <Col xs={12}>
          <label className="error-message">{ error.error }</label>
        </Col>
      );
    }
    return (
      <ContentWrapper />
    );
  }

  /* Refund Section */
  renderRefund() {
    const { captured, refunded } = this.state.info;
    if (this.state.info.method && !captured) {
      return (
        <ContentWrapper>
          <Row>
            <Col xs={12}>
              <h4><Translate value="refund" /></h4>
            </Col>
            { refunded ? '' : this.renderRefundOptions() }
            { refunded ? '' : this.renderRefundReasons() }
          </Row>
          <Row>
            <Col xs={12}>
              { this.renderRefundButton() }
              { this.renderPrint() }
            </Col>
            { this.renderRefundError() }
          </Row>
        </ContentWrapper>
      );
    } else if (captured && !this.state.info.method) {
      return (
        <ContentWrapper>
          <Row>
            <Col xs={12}>
              <h4><Translate value="refund" /></h4>
            </Col>
            { refunded ? '' : this.renderRefundOptions() }
            { refunded ? '' : this.renderRefundReasons() }
          </Row>
          <Row>
            <Col xs={12}>
              { this.renderRefundButton() }
              { this.renderPrint() }
            </Col>
            { this.renderRefundError() }
          </Row>
        </ContentWrapper>
      );
    } else {
      return <ContentWrapper />;
    }
  }

  render() {
    return (
      <ContentWrapper>
        {/* Payment details */}
        { this.renderPaymentDetails() }
        {/* End Payment details */}

        {/* Billing info */}
        { this.renderAddress() }
        {/* End billing info */}

        {/* Refund options */}
        { this.renderRefund() }
        {/* End refund options */}
      </ContentWrapper>
    );
  }
}

export default MSOPaymentInfo;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/MSOPaymentInfo.jsx